import { IUserData, UpdateUserResponse } from '../store/reducers/userReducer'
import apiBase from '../utils/baseApi'

export async function getUser(): Promise<{ data: IUserData }> {
  try {
    const response = await apiBase.get<{ data: IUserData }>('/v1/users/current')
    return response.data
  } catch (error) {
    console.error('Error getting user:', error)
    throw error
  }
}

export async function updateUser(
  userSub: string,
  data: { firstName: string; lastName: string },
): Promise<UpdateUserResponse> {
  try {
    const response = await apiBase.patch<UpdateUserResponse>(
      `/v2/users/${userSub}`,
      {
        first_name: data.firstName,
        last_name: data.lastName,
      },
    )
    return response.data
  } catch (error) {
    console.error('Error updating user:', error)
    throw error
  }
}
